/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponseIconAsset } from '../../models/api-response-icon-asset';

export interface CreateIconAsset$Params {
  'x-api-requestId': string;
  'x-api-canal': string;
      body?: {
'iconAsset': string;
'file'?: Blob;
}
}

export function createIconAsset(http: HttpClient, rootUrl: string, params: CreateIconAsset$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseIconAsset>> {
  const rb = new RequestBuilder(rootUrl, createIconAsset.PATH, 'post');
  if (params) {
    rb.header('x-api-requestId', params['x-api-requestId'], {});
    rb.header('x-api-canal', params['x-api-canal'], {});
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponseIconAsset>;
    })
  );
}

createIconAsset.PATH = '/v1/api/admin-ui/icon-asset/create';
